import { render, staticRenderFns } from "./c-mobile-simple-scroll.vue?vue&type=template&id=65f28892&scoped=true"
import script from "./c-mobile-simple-scroll.vue?vue&type=script&lang=js"
export * from "./c-mobile-simple-scroll.vue?vue&type=script&lang=js"
import style0 from "./c-mobile-simple-scroll.vue?vue&type=style&index=0&id=65f28892&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f28892",
  null
  
)

export default component.exports